import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Params } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ProtectOrderModel } from '@zero/shared/util-models';
import { TradeSuccessPageBase } from '@zero/trade/feature-trade/base';
import { commonRoutes } from 'constants/web-app-constants';
import { LottieComponent } from 'ngx-lottie';
import { ProtectOrderComponent } from '../../components/protect-order/protect-order.component';
import { SecureTanHintComponent } from '../../components/secure-tan-hint/secure-tan-hint.component';
import { KnowledgeAndExperienceComponent } from '../knowledge-and-experience/knowledge-and-experience.component';

@Component({
  selector: 'trade-success',
  templateUrl: './trade-success.component.html',
  styleUrls: ['./trade-success.component.scss'],
  imports: [LottieComponent, SecureTanHintComponent, ProtectOrderComponent, AsyncPipe, TranslocoPipe, KnowledgeAndExperienceComponent],
})
export class TradeSuccessComponent extends TradeSuccessPageBase implements OnInit, OnDestroy {
  readonly #darkCssClass = 'dark';

  @Output() public goInit = new EventEmitter<Params>();

  public async ngOnInit() {
    await this.init();
    if (!this.isReady) {
      this.router.navigate([commonRoutes.postlogin.buyAndSell]);
      return;
    }

    this.#addCssToBody();
  }

  public ngOnDestroy() {
    this.#removeCssFromBody();
    this.destroy();
  }

  public onProtectOrder = (protectOrder: ProtectOrderModel) => this.goInit.emit(this.getProtectOrderParams(protectOrder));

  #removeCssFromBody = () => this.document.body.classList.remove(this.#darkCssClass);

  #addCssToBody = () => this.document.body.classList.add(this.#darkCssClass);
}
